import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';
import { ROUTES, USER_ROLES } from '../constants';

export const DefaultRedirect: React.FC = () => {
  const { user } = useAuth();

  // If user is authenticated, redirect based on role
  if (user) {
    // Check if user has completed onboarding
    const hasCompletedOnboarding = user.onboarding_completed;

    if (!hasCompletedOnboarding && user.role === USER_ROLES.USER) {
      return <Navigate to={ROUTES.ONBOARDING} replace />;
    }

    // Check if user needs to select a plan
    if (user.subscription_status === 'pending' ||
        user.subscription_status === 'canceled' ||
        user.subscription_status === 'past_due') {
      return <Navigate to="/select-plan" replace />;
    }

    // Redirect based on user role
    if (user.role === USER_ROLES.ADMIN || user.role === USER_ROLES.SENIOR_REVIEWER) {
      return <Navigate to={ROUTES.QUESTIONS_MANAGEMENT} replace />;
    }

    if (user.role === USER_ROLES.REVIEWER) {
      return <Navigate to={ROUTES.REVIEW} replace />;
    }

    // Normal users go to dashboard
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  // If not authenticated, show landing page
  return <Navigate to="/landing" replace />;
};